module.exports = __webpack_public_path__ + "static/media/village.a255f8a0.svg";